// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../../i18n/l10n';

import CurrencyExposant from './CurrencyExposant';

const Wrap = styled.div`
  background: ${({ theme }) => theme.grids.gradients.black()};
  border-radius: 4px;
  box-shadow: 0 0.1em 0.1em 0 rgba(0, 0, 0, 0.6);
  padding: 0 1em;
`;

const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0;
  border-bottom: solid 2px ${({ theme }) => theme.grids.colors.darkgrey5};
  &:last-of-type {
    border-bottom: none;
  }
`;
const Label = styled.div`
  color: #fff;
`;
const Value = styled.div`
  color: ${({ theme }) => theme.grids.colors.lightgrey};
`;

type GridsPrizepoolProps = {
  className: string | null;
  netStakes: number | null;
  addedAmount: number | null;
  postponedAmount: number | null;
  distributedAmount: number | null;
  guaranteedAmount: number | null;
  onlyGuarenteed: boolean;
};

const GridsPrizepool = ({
  className,
  netStakes,
  addedAmount,
  postponedAmount,
  distributedAmount,
  guaranteedAmount,
  onlyGuarenteed,
}: GridsPrizepoolProps) => {
  return (
    <Wrap className={className}>
      {!onlyGuarenteed && (
        <>
          {netStakes ? (
            <Line>
              <Label>{__('Amount collected:')}</Label>
              <Value noHighlight>
                <CurrencyExposant amount={netStakes} />
              </Value>
            </Line>
          ) : null}
          {addedAmount ? (
            <Line>
              <Label>{__('including rank 1 deferral:')}</Label>
              <Value noHighlight>
                <CurrencyExposant amount={addedAmount} />
              </Value>
            </Line>
          ) : null}
          {postponedAmount ? (
            <Line>
              <Value>{__('No rank 1 winners')}</Value>
            </Line>
          ) : null}
          {distributedAmount ? (
            <Line>
              <Label>{__('Amount shared out:')}</Label>
              <Value>
                <CurrencyExposant amount={distributedAmount} />
              </Value>
            </Line>
          ) : null}
          {postponedAmount ? (
            <Line>
              <Label>{__('Amount to be carried forward:')}</Label>
              <Value noHighlight>
                <CurrencyExposant amount={postponedAmount} />
              </Value>
            </Line>
          ) : null}
        </>
      )}
      {guaranteedAmount ? (
        <Line>
          <Label>{__('Guarantee:')}</Label>
          <Value noHighlight>
            <CurrencyExposant amount={guaranteedAmount} />
          </Value>
        </Line>
      ) : null}
    </Wrap>
  );
};

export default GridsPrizepool;
